/**
 * @file コンポーネント：チェックボックス スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledCheckbox = styled.label`
    display: inline-flex;
    align-items: center;
    margin-bottom: 0;
    cursor: pointer;
`;

export const StyledCheckboxInput = styled.input`
    margin-right: 6px;
`;

export const StyledCheckboxText = styled.span`
    color: #000000;
    font-size: 13px;
`;
